import { ADD_AGENDA_ITEM_GUESTS } from '../actionTypes'

export const addAgendaItemsGuests = (data: object) => ({
  type: ADD_AGENDA_ITEM_GUESTS.name,
  api: {
    url: 'agenda_items/add_guests',
    data,
  },
})
